import { call, put, select, takeEvery } from 'redux-saga/effects';
import { gcApi } from '../config/axios';
import GCSyncUtil from 'utils/GCSyncUtil';
import AnalyticsUtil from 'utils/AnalyticsUtil';
import { shouldLaunchGarminExpressSelector } from 'reducers/device/deviceBackups';

import {
    FETCH_ALL_AVAILABLE_DEVICE_BACKUPS,
    FETCH_ALL_AVAILABLE_DEVICE_BACKUPS_START,
    FETCH_ALL_AVAILABLE_DEVICE_BACKUPS_SUCCESS,
    FETCH_ALL_AVAILABLE_DEVICE_BACKUPS_FAIL,
    FETCH_COMPATIBLE_DEVICE_BACKUPS,
    FETCH_COMPATIBLE_DEVICE_BACKUPS_START,
    FETCH_COMPATIBLE_DEVICE_BACKUPS_FAIL,
    RESTORE_DEVICE_BACKUP,
    RESTORE_DEVICE_BACKUP_START,
    RESTORE_DEVICE_BACKUP_SUCCESS,
    RESTORE_DEVICE_BACKUP_FAIL,
    REMOVE_DEVICE_BACKUP,
    REMOVE_DEVICE_BACKUP_START,
    REMOVE_DEVICE_BACKUP_SUCCESS,
    REMOVE_DEVICE_BACKUP_FAIL,
    FETCH_DEVICE_BACKUPS_SUMMARY,
    FETCH_DEVICE_BACKUPS_SUMMARY_START,
    FETCH_DEVICE_BACKUPS_SUMMARY_SUCCESS,
    FETCH_DEVICE_BACKUPS_SUMMARY_FAIL
} from '../actions/ActionTypes';
import { fetchCompatibleDeviceBackupsSuccess, shouldLaunchGarminExpressAction } from 'actions/deviceBackupsActions';

/** @typedef {import('reducers/device/types/DeviceBackupDTO').DeviceBackupDTO} DeviceBackupDTO */

// Workers
export function* fetchAllAvailableBackupsSaga() {
    try {
        yield put({
            type: FETCH_ALL_AVAILABLE_DEVICE_BACKUPS_START
        });

        const response = yield call(gcApi.get, `devicebackup-service/backup`);

        yield put({
            type: FETCH_ALL_AVAILABLE_DEVICE_BACKUPS_SUCCESS,
            allAvailableDeviceBackups: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_ALL_AVAILABLE_DEVICE_BACKUPS_FAIL
        });
    }
}

/**
 * @param {ReturnType<typeof fetchCompatibleDeviceBackups>} action
 */
export function* fetchCompatibleDeviceBackupsSaga(action) {
    const { deviceId } = action.payload;

    try {
        yield put({
            type: FETCH_COMPATIBLE_DEVICE_BACKUPS_START
        });

        const response = yield call(gcApi.get, `devicebackup-service/backup/${deviceId}`);

        yield put(fetchCompatibleDeviceBackupsSuccess({ compatibleDeviceBackups: response.data }));
    } catch (e) {
        yield put({
            type: FETCH_COMPATIBLE_DEVICE_BACKUPS_FAIL
        });
    }
}

export function* removeDeviceBackupSaga(action) {
    const { deviceId } = action.payload;

    try {
        yield put({
            type: REMOVE_DEVICE_BACKUP_START
        });

        yield call(gcApi.delete, `devicebackup-service/backup/${deviceId}`);

        yield put({
            type: REMOVE_DEVICE_BACKUP_SUCCESS,
            deviceId
        });
    } catch (e) {
        yield put({
            type: REMOVE_DEVICE_BACKUP_FAIL
        });
    }
}

export function* restoreDeviceBackupSaga(action) {
    const { targetDeviceId, deviceBackupId, currentDeviceName } = action.payload;
    const shouldLaunchGarminExpress = yield select(shouldLaunchGarminExpressSelector);

    try {
        yield put({
            type: RESTORE_DEVICE_BACKUP_START
        });

        yield call(gcApi.post, `devicebackup-service/backup/restoreDevice/${targetDeviceId}/${deviceBackupId}`);

        yield put({
            type: RESTORE_DEVICE_BACKUP_SUCCESS
        });

        if (shouldLaunchGarminExpress) {
            GCSyncUtil.openAgent(targetDeviceId);
            //reset checked state to the initial one
            yield put(shouldLaunchGarminExpressAction(false));
        }

        AnalyticsUtil.push({
            event: 'track_event',
            category: 'Device Backups Restore Modal',
            action: 'Clicked restore button for confirmation',
            label: currentDeviceName
        });
    } catch (e) {
        yield put({
            type: RESTORE_DEVICE_BACKUP_FAIL
        });
    }
}

export function* fetchBackupsSummarySaga() {
    try {
        yield put({
            type: FETCH_DEVICE_BACKUPS_SUMMARY_START
        });

        const response = yield call(gcApi.get, `devicebackup-service/backup/summary`);

        yield put({
            type: FETCH_DEVICE_BACKUPS_SUMMARY_SUCCESS,
            backupsSummary: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_DEVICE_BACKUPS_SUMMARY_FAIL
        });
    }
}

// Watchers
export const deviceBackupSagas = [
    takeEvery(FETCH_ALL_AVAILABLE_DEVICE_BACKUPS, fetchAllAvailableBackupsSaga),
    takeEvery(FETCH_COMPATIBLE_DEVICE_BACKUPS, fetchCompatibleDeviceBackupsSaga),
    takeEvery(REMOVE_DEVICE_BACKUP, removeDeviceBackupSaga),
    takeEvery(RESTORE_DEVICE_BACKUP, restoreDeviceBackupSaga),
    takeEvery(FETCH_DEVICE_BACKUPS_SUMMARY, fetchBackupsSummarySaga)
];
